export default "__VITE_ASSET__4f23cda2__"